import { ApiError, LocalValidationError } from '@clim/client-core';

export function errorMessage(err: unknown): string {
  if (err instanceof LocalValidationError) {
    const fields = Object.values(err.fields);
    return fields.length ? fields.join(' · ') : err.message;
  }
  if (err instanceof ApiError) {
    const details = Array.isArray(err.details) ? (err.details as { message: string }[]).map((d) => d.message).join(' · ') : '';
    return details ? `${err.message} : ${details}` : err.message;
  }
  return err instanceof Error ? err.message : 'Erreur inattendue';
}

export function fieldErrors(err: unknown): Record<string, string> {
  if (err instanceof LocalValidationError) return err.fields;
  if (err instanceof ApiError && Array.isArray(err.details)) {
    return Object.fromEntries((err.details as { path: string; message: string }[]).map((d) => [d.path, d.message]));
  }
  return {};
}
